var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import { Alert, Autocomplete, Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useCreateLeagueTeamInvitation, useSearchInvitableTeams, } from "../api/InvitationApiProvider";
import { useRetrieveLeague, useRetrieveLeagueTeams, } from "../api/LeagueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ROUTES } from "../breadcrumbs/routeConfig";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { TeamAvatar } from "../teams/TeamAvatar";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useDebounce } from "../utils/useDebounce";
import { useNumericParams } from "../utils/useNumericParams";
export var SendLeagueInvitation = function () {
    var _a;
    var leagueId = useNumericParams().id;
    var navigate = useNavigate();
    var _b = useRetrieveUserLeaguePermissions({ leagueId: leagueId }), permissions = _b.data, isPermLoading = _b.isLoading;
    var canModify = (permissions === null || permissions === void 0 ? void 0 : permissions.canModify) === true;
    var _c = useRetrieveLeague({ id: leagueId, enabled: canModify }), league = _c.data, isLeagueLoading = _c.isLoading, leagueError = _c.error;
    var _d = useRetrieveLeagueTeams({ leagueId: leagueId, enabled: canModify }), leagueTeams = _d.data, isTeamsLoading = _d.isLoading, teamsError = _d.error;
    var _f = __read(useState(""), 2), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = __read(useState(""), 2), searchTerm = _g[0], setSearchTerm = _g[1];
    var debouncedSearchTerm = useDebounce(searchTerm, 300);
    var _h = useSearchInvitableTeams({
        leagueId: leagueId,
        searchTerm: debouncedSearchTerm || undefined,
        enabled: canModify,
    }), searchResults = _h.data, isSearchFetching = _h.isFetching;
    var _j = useForm({
        defaultValues: {
            teamId: null,
            mergeTeamId: null,
            message: "",
        },
    }), control = _j.control, handleSubmit = _j.handleSubmit, watch = _j.watch, errors = _j.formState.errors;
    var createMutation = useCreateLeagueTeamInvitation({
        leagueId: leagueId,
        onMutate: function () { },
        onSuccess: function () {
            return navigate(ROUTES.LEAGUE_INVITATIONS.replace(":id", String(leagueId)));
        },
        onError: function (error) {
            var _a;
            var data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
            if (data) {
                var messages = Object.values(data).flat();
                setErrorMessage(messages.join(" "));
            }
            else {
                setErrorMessage("Failed to send invitation.");
            }
        },
    });
    var onSubmit = function (data) {
        if (!data.teamId)
            return;
        createMutation.mutate(__assign(__assign({ teamId: data.teamId }, (data.mergeTeamId ? { mergeTeamId: data.mergeTeamId } : {})), (data.message ? { message: data.message } : {})));
    };
    if (isPermLoading || (canModify && (isLeagueLoading || isTeamsLoading))) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (leagueError || teamsError || !league) {
        return _jsx(ErrorView, { error: leagueError || teamsError });
    }
    var teamOptions = ((searchResults === null || searchResults === void 0 ? void 0 : searchResults.results) || []).map(function (t) { return ({
        id: t.id,
        label: t.name,
        logo: t.logo,
        primaryColour: t.primaryColour,
        secondaryColour: t.secondaryColour,
    }); });
    var mergeableTeams = (leagueTeams || []).map(function (m) { return m.team; });
    var selectedTeamId = watch("teamId");
    return (_jsxs(React.Fragment, { children: [_jsxs(Typography, { variant: "h4", gutterBottom: true, children: ["Invite Team \u2014 ", league.name] }), _jsxs(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, role: "form", sx: { maxWidth: 600, mt: 2 }, children: [_jsx(Typography, { variant: "subtitle2", color: "text.secondary", sx: { mb: 2 }, children: "Search for a team to invite to this league." }), _jsx(Controller, { name: "teamId", control: control, rules: {
                            validate: function (value) {
                                if (!value)
                                    return "Please select a team";
                                return true;
                            },
                        }, render: function (_a) {
                            var field = _a.field;
                            return (_jsx(Autocomplete, { options: teamOptions, getOptionLabel: function (option) {
                                    return typeof option === "string" ? option : option.label;
                                }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, filterOptions: function (x) { return x; }, loading: isSearchFetching, onInputChange: function (_e, value) { return setSearchTerm(value); }, onChange: function (_e, value) {
                                    field.onChange(value ? value.id : null);
                                }, renderOption: function (props, option) { return (_createElement(Box, __assign({ component: "li" }, props, { key: option.id, sx: { display: "flex", alignItems: "center", gap: 1 } }),
                                    _jsx(TeamAvatar, { team: {
                                            name: option.label,
                                            logo: option.logo,
                                            primaryColour: option.primaryColour,
                                            secondaryColour: option.secondaryColour,
                                        }, size: 32, showTooltip: false }),
                                    option.label)); }, renderInput: function (params) {
                                    var _a;
                                    return (_jsx(TextField, __assign({}, params, { label: "Search for Team", margin: "normal", fullWidth: true, error: !!errors.teamId, helperText: (_a = errors.teamId) === null || _a === void 0 ? void 0 : _a.message })));
                                } }));
                        } }), selectedTeamId && mergeableTeams.length > 0 && (_jsxs(Box, { sx: { mt: 2 }, children: [_jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { children: "Merge Placeholder Team (Optional)" }), _jsx(Controller, { name: "mergeTeamId", control: control, render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (_jsxs(Select, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", label: "Merge Placeholder Team (Optional)", children: [_jsx(MenuItem, { value: "", children: _jsx("em", { children: "None" }) }), mergeableTeams.map(function (team) { return (_jsx(MenuItem, { value: team.id, children: team.name }, team.id)); })] })));
                                        } }), _jsx(Typography, { variant: "caption", color: "text.secondary", sx: { mt: 0.5 }, children: "Optionally select an existing placeholder team whose league data will be merged into the invited team on accept." })] }), watch("mergeTeamId") && (_jsxs(Alert, { severity: "warning", icon: _jsx(MergeTypeIcon, {}), sx: { mt: 2 }, children: [_jsx("strong", { children: "Data merge:" }), " When the invited team accepts, all league data (results, standings, stats) from", " ", _jsx("strong", { children: (_a = mergeableTeams.find(function (t) { return t.id === watch("mergeTeamId"); })) === null || _a === void 0 ? void 0 : _a.name }), " ", "will be transferred to the invited team and the placeholder will be removed from the league."] }))] })), _jsx(Controller, { name: "message", control: control, render: function (_a) {
                            var field = _a.field;
                            return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, label: "Message (Optional)", multiline: true, rows: 3 })));
                        } }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", disabled: createMutation.isLoading, sx: { mt: 3, mb: 2 }, children: createMutation.isLoading ? "Sending..." : "Send Invitation" })] }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
